export const recruitmentTabsArticle = {
  title: 'Recruitment Portal: Tabs Overview',
  slug: 'recruitment-tabs',
  content: `Recruitment Portal: Tabs Overview

Navigate the ATS workflow using the top tabs.

1) Dashboard
- Review active jobs, total applications, and interviews.

2) Jobs
- Create and manage job posts.

3) Pipeline
- Track applicants by stage in the pipeline.

4) Applications & Talent Pool
- Review incoming applications and candidate records.

5) Interviews & Offers
- Manage interview scheduling and offers.

6) Embed Portal
- Generate embed code for your public job board.
`,
};
